import { Box } from "@chakra-ui/react"
import SystemsTable from "@hydrologiq/shared/system/SystemsTable"
import SystemCreate from "../components/SystemCreate"

function Systems() {
  return <SystemsTable headerActions={<SystemCreate />} />
}

export default Systems
